/* eslint-disable prettier/prettier */
export const drawSth = () => {
  console.log("TODOOOOOO")
}
